module.exports = __webpack_public_path__ + "static/media/emojis2_23.4216dd61.svg";